module.exports = __webpack_public_path__ + "img/visa.df2eb2e0.png";